import { CommunityChannelApi } from '@ps/api/community-channel';
import { withClientAPI } from '@ps/functions/utils/api';

/**
 * Update the current user's per-channel membership settings — used
 * by the Notifications toggle (`muted`) and the "Mentions in
 * Channel" sub-option (`subscribedToMentions`).
 *
 * The API expects a `memberId` path param; that's the user id since
 * the membership doc is keyed by user under the channel's `members`
 * subcollection.
 */
export async function updateChannelMembership({
  creatorId,
  channelId,
  userId,
  muted,
  subscribedToMentions,
  subscribedToUpdatesOfCreator,
}: {
  creatorId: string;
  channelId: string;
  userId: string;
  muted?: boolean;
  subscribedToMentions?: boolean;
  subscribedToUpdatesOfCreator?: boolean;
}): Promise<void> {
  const api = withClientAPI(CommunityChannelApi);
  await api.communityChannelApiControllerUpdateMemberInCommunityChannel({
    sellerId: creatorId,
    channelId,
    memberId: userId,
    UpdateCommunityChannelMemberRequest: {
      muted,
      subscribedToMentions,
      subscribedToUpdatesOfCreator,
    },
  });
}
